import styled, { css } from "styled-components";

const labelStyles = css`
  ${(props) => props.labelStyles}
`;
const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const OptionsWrapper = styled.div`
  padding: 1rem 0rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 10px;
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
`;

export const ErrorDiv = styled.div`
  height: 35px;
  border: solid 1px red;
  padding: 7px;
`;

export const ContainerLabel = styled.label`
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: ${(props) => props.color ?? "#1bace4"};
  text-align: center;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
  ${labelStyles}
`;

export const TextInputContainer = styled.div`
  position: relative;
`;
export const TextInputLabel = styled.label`
  position: relative !important;
  margin-bottom: -8px;
  margin-left: -7px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: ${(props) => (props.error === "" ? "#1bace4" : "red")};
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  &::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const RequiredFieldDivError = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: Lato;
  line-height: 1;
  margin: 0;
  padding: 0;
  position: relative;
  white-space: nowrap;
  font-style: italic;
}
`;
